<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show_add_typefood === true">เพิ่มประเภทอาหารเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_status === true">เปลี่ยนสถานะเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_delete_food === true">ลบอาหารเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_delete_topping === true">ลบท็อปปิ้งเรียบร้อย</v-alert>
        <v-alert type="error" class="alert_success" v-if="alert_show_delete_topping_false === true">{{ message_delete_topping_false }}</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_delete_type_food === true">ลบประเภทอาหารเรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <div class="loading_up_down" v-if="loading_up_down === true">
        <v-progress-circular indeterminate size="60" color="primary"></v-progress-circular>
    </div>
    <div v-if="title === 'food'">
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div v-if="loading_page === false">
            <div class="text-right mb-2" v-if="$store.state.userProfile.per_add_food == 1">
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn width="20%" color="#28ab28" class="white--text" height="50" v-bind="attrs" v-on="on">
                            <div class="d-flex justify-space-between align-center menu_add_food">
                                <div>เพิ่ม</div>
                                <div>
                                    <v-icon>mdi-menu-down</v-icon>
                                </div>

                            </div>

                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item link @click="printList()">
                            <v-list-item-title class="menu_add_food">ประเภทอาหาร</v-list-item-title>
                        </v-list-item>
                        <v-list-item link @click="$router.push('/addfood')">
                            <v-list-item-title class="menu_add_food">อาหาร</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>
            <div class="d-flex mb-2" v-for="(detail,key) in data" :key="key">
                <div class="d-flex flex-column">
                    <v-icon size="30" @click="changeNoFoodCategory(detail.No,'up',key)" v-if="key != 0">mdi-arrow-up-bold-circle</v-icon>
                    <v-icon size="30" color="rgba(0, 0, 0, 0.3)" v-if="key == 0">mdi-arrow-up-bold-circle</v-icon>
                    <v-icon size="30" @click="changeNoFoodCategory(detail.No,'down',key)" v-if="key != Object.keys(data).length - 1">mdi-arrow-down-bold-circle</v-icon>
                    <v-icon size="30" color="rgba(0, 0, 0, 0.3)" v-if="key == Object.keys(data).length - 1">mdi-arrow-down-bold-circle</v-icon>
                </div>
                <v-expansion-panels>
                    <v-expansion-panel>
                        <v-expansion-panel-header class="color_font_manage_food_type">
                            <div>{{ detail.name }} ({{ detail.count }}) <span @click="detailTypeFood(detail.id)" v-if="$store.state.userProfile.per_edit_food == 1">แก้ไข</span><span @click="confirmTypeFoodDelete(detail.id)" v-if="$store.state.userProfile.per_edit_food == 1">ลบ</span></div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="body_food_manage_food_type">
                            <v-card color="blue lighten-5" class="pa-3 d-flex justify-space-between align-center mt-2" v-for="(food,key_detail) in detail.menuList" :key="key_detail">
                                <div class="d-flex align-center w_full_detail_manage_food_type">
                                    <div class="d-flex flex-column">
                                        <v-icon size="30" @click="changeNoFood(food.No,'up',key,key_detail,detail.id)" v-if="key_detail != 0">mdi-arrow-up-bold-circle</v-icon>
                                        <v-icon size="30" color="rgba(0, 0, 0, 0.3)" v-if="key_detail == 0">mdi-arrow-up-bold-circle</v-icon>
                                        <v-icon size="30" @click="changeNoFood(food.No,'down',key,key_detail,detail.id)" v-if="key_detail != Object.keys(detail.menuList).length - 1">mdi-arrow-down-bold-circle</v-icon>
                                        <v-icon size="30" color="rgba(0, 0, 0, 0.3)" v-if="key_detail == Object.keys(detail.menuList).length - 1">mdi-arrow-down-bold-circle</v-icon>
                                    </div>
                                    <div class="mr-2 img_menu_food_manage_food_type">
                                        <img :src="food.picture" v-if="food.picture">
                                        <img :src="food_image" v-if="!food.picture">
                                    </div>
                                    <div class="w_full_name_detail_manage_food_type">
                                        <div>{{ food.name }} <span class="description_manage_food_type">( {{ food.nameEng }} )</span></div>
                                        <div>{{ food.price }}฿</div>
                                        <div class="description_manage_food_type">{{ food.description ? food.description : '' }}</div>
                                    </div>
                                </div>
                                <div class="d-flex flex-column justify-center align-center w_status_manage_food_type">
                                    <div>{{ food.status == 1 ? 'พร้อมเสริฟ' : food.status == 0 ? 'ของหมด': ''}}</div>
                                    <div>
                                        <v-switch class="ma-0 pa-0" hide-details="true" color="success" v-model="food.status" @click="changeFoodStatus(food.id)"></v-switch>
                                    </div>
                                </div>
                                <div class="page_detail_manage_food_type" v-if="$store.state.userProfile.per_edit_food == 1">
                                    <v-menu offset-y>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
                                        </template>
                                        <v-list>
                                            <v-list-item class="page_edit_manage_food_type" @click="pageFoodDetail(food.id)">
                                                <v-list-item-title>แก้ไขอาหาร</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item class="page_edit_manage_food_type" @click="confirmFoodDelete(food.id)">
                                                <v-list-item-title>ลบอาหาร</v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </div>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
        </div>
    </div>

    <div v-if="title === 'topping'">
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div v-if="loading_page === false">
            <div class="text-right mb-2" v-if="$store.state.userProfile.per_add_food == 1">
                <v-btn width="20%" height="50" color="#28ab28" class="white--text" @click="$router.push('/addtopping')">
                    <div class="menu_add_food">เพิ่มท็อปปิ้ง</div>
                </v-btn>
            </div>
            <div class="d-flex mb-2" v-for="(detail,key) in data" :key="key">
                <div class="d-flex flex-column">
                    <v-icon size="30" @click="changeNoTopingCategory(detail.No,'up',key)" v-if="key != 0">mdi-arrow-up-bold-circle</v-icon>
                    <v-icon size="30" color="rgba(0, 0, 0, 0.3)" v-if="key == 0">mdi-arrow-up-bold-circle</v-icon>
                    <v-icon size="30" @click="changeNoTopingCategory(detail.No,'down',key)" v-if="key != Object.keys(data).length - 1">mdi-arrow-down-bold-circle</v-icon>
                    <v-icon size="30" color="rgba(0, 0, 0, 0.3)" v-if="key == Object.keys(data).length - 1">mdi-arrow-down-bold-circle</v-icon>
                </div>
                <v-expansion-panels>
                    <v-expansion-panel>
                        <v-expansion-panel-header class="color_font_manage_food_type">
                            <div>{{ detail.topingcategories_name }} <span @click="pageToppingDetail(detail.id)" v-if="$store.state.userProfile.per_edit_food == 1">แก้ไข</span><span @click="confirmToppingDelete(detail.id)" v-if="$store.state.userProfile.per_edit_food == 1">ลบ</span></div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="body_food_manage_food_type">
                            <v-card color="blue lighten-5" class="pa-3 d-flex justify-space-between align-center mt-2" v-for="(topping,key_detail) in detail.toping_list" :key="key_detail">
                                <div class="d-flex align-center">
                                    <div class="d-flex flex-column">
                                        <v-icon size="30" @click="changeNoToping(topping.No,'up',key,key_detail,detail.id)" v-if="key_detail != 0">mdi-arrow-up-bold-circle</v-icon>
                                        <v-icon size="30" color="rgba(0, 0, 0, 0.3)" v-if="key_detail == 0">mdi-arrow-up-bold-circle</v-icon>
                                        <v-icon size="30" @click="changeNoToping(topping.No,'down',key,key_detail,detail.id)" v-if="key_detail != Object.keys(detail.toping_list).length - 1">mdi-arrow-down-bold-circle</v-icon>
                                        <v-icon size="30" color="rgba(0, 0, 0, 0.3)" v-if="key_detail == Object.keys(detail.toping_list).length - 1">mdi-arrow-down-bold-circle</v-icon>
                                    </div>
                                    <div class="d-flex align-center">
                                        <div>{{ topping.name }}</div>
                                    </div>
                                </div>
                                <div class="d-flex justify-center align-center">
                                    <div>{{ topping.status == 1 ? 'พร้อม' : topping.status == 0 ? 'ของหมด': ''}}</div>
                                    <div>
                                        <v-switch class="ma-0 pa-0" hide-details="true" color="success" v-model="topping.status" @click="changeToppingStatus(topping.id)"></v-switch>
                                    </div>
                                </div>
                            </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
        </div>
    </div>

    <v-dialog v-model="open_type_food" persistent max-width="600px">
        <div v-if="loading_page_add_typefood === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <v-card v-if="loading_page_add_typefood === false">
            <v-form ref="form" @submit.prevent="addTypeFood()">
                <v-card-title>
                    <div class="d-flex justify-center align-center">
                        <div class="img_modal_add_food">
                            <img src="@/assets/list.png">
                        </div>
                        <div class="ml-1">
                            เพิ่มประเภทอาหาร
                        </div>
                    </div>
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field label="ชื่อประเภทอาหารภาษาไทย" :rules="[v => !!v || 'กรุณากรอกชื่อประเภทอาหารภาษาไทย']" v-model="type_food_name" required outlined></v-text-field>
                                <v-text-field label="ชื่อประเภทอาหารภาษาอังกฤษ"  v-model="type_food_name_en"  outlined></v-text-field>
                                <v-select label="เลือกเครื่องพิมพ์" :items="print_list" item-text="name" item-value="id" :rules="[v => !!v || 'กรุณาเลือกเครื่องพิมพ์']" v-model="printer_id" required outlined>
                                </v-select>
                                <!-- <div class="d-flex align-center">
                                    <div>
                                        <v-switch class="ma-0 pa-0" hide-details="true" color="success" v-model="show_website"></v-switch>
                                    </div>
                                    <div>แสดงหน้าเว็บไซต์</div>
                                </div> -->
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#28ab28" class="white--text" height="50" type="submit">
                        บันทึก
                    </v-btn>
                    <v-btn color="error" type="button" height="50" @click="open_type_food = false">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>

    <v-dialog v-model="open_edit_type_food" persistent max-width="600px">
        <div v-if="loading_page_edit_typefood === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <v-card v-if="loading_page_edit_typefood === false">
            <v-form ref="edit_form" @submit.prevent="editTypeFood()">
                <v-card-title>
                    <div class="d-flex justify-center align-center">
                        <div class="img_modal_add_food">
                            <img src="@/assets/list.png">
                        </div>
                        <div class="ml-1">
                            แก้ไขประเภทอาหาร
                        </div>
                    </div>
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field label="ชื่อประเภทอาหารภาษาไทย" :rules="[v => !!v || 'กรุณากรอกชื่อประเภทอาหารภาษาไทย']" v-model="edit_type_food_name" required outlined></v-text-field>
                                <v-text-field label="ชื่อประเภทอาหารภาษาอังกฤษ"  v-model="edit_type_food_name_en" required outlined></v-text-field>
                                <v-select label="เลือกเครื่องพิมพ์" :items="print_list" item-text="name" item-value="id" :rules="[v => !!v || 'กรุณาเลือกเครื่องพิมพ์']" v-model="edit_printer_id" required outlined>
                                </v-select>
                                <!--                                <div class="d-flex align-center mb-5">-->
                                <!--                                    <i :class="edit_icon_value + ' icon_size_manage_food_type mr-2'" v-if="edit_icon"></i>-->
                                <!--                                    <v-icon class="icon_size_manage_food_type" v-if="!edit_icon">mdi-minus</v-icon>-->
                                <!--                                    <v-select label="เลือกไอคอน" :items="icon_list" hide-details="auto" item-text="icon_name" item-value="id" :rules="[v => !!v || 'กรุณาเลือกไอคอน']" v-model="edit_icon" required outlined>-->
                                <!--                                        <template slot="item" slot-scope="data">-->
                                <!--                                            <i :class="data.item.icon_name"></i>&nbsp;{{ data.item.icon_name }}-->
                                <!--                                        </template>-->
                                <!--                                    </v-select>-->
                                <!--                                </div>-->
                                <!--                                <v-radio-group class="mt-0 mb-5" v-model="edit_type_status" :rules="[v => !!v || 'กรุณาเลือกการทำงาน']" required hide-details="auto">-->
                                <!--                                    <div class="d-flex">-->
                                <!--                                        <div class="d-flex">-->
                                <!--                                            <v-radio color="primary" class="mb-0" value="1"></v-radio>-->
                                <!--                                            <div class="mr-1">ชุดเซ็ท</div>-->
                                <!--                                        </div>-->
                                <!--                                        <div class="d-flex">-->
                                <!--                                            <v-radio color="primary" class="mb-0" value="2"></v-radio>-->
                                <!--                                            <div class="mr-1">ส่งทั่วประเทศ</div>-->
                                <!--                                        </div>-->
                                <!--                                        <div class="d-flex">-->
                                <!--                                            <v-radio color="primary" class="mb-0" value="3"></v-radio>-->
                                <!--                                            <div class="mr-1">ทาน + ซื้อกลับบ้าน</div>-->
                                <!--                                        </div>-->
                                <!--                                    </div>-->
                                <!--                                </v-radio-group>-->
                                <!-- <div class="d-flex align-center">
                                    <div>
                                        <v-switch class="ma-0 pa-0" hide-details="true" color="success" v-model="edit_show_website"></v-switch>
                                    </div>
                                    <div>แสดงหน้าเว็บไซต์</div>
                                </div> -->
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#28ab28" class="white--text" height="50" type="submit">
                        บันทึก
                    </v-btn>
                    <v-btn color="error" type="button" height="50" @click="open_edit_type_food = false">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>

    <v-dialog v-model="open_confirm_delete_food" persistent max-width="600px">
        <div v-if="loading_page_delete_food === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <v-card v-if="loading_page_delete_food === false">
            <v-card-title>
                คำเตือน
            </v-card-title>

            <v-card-text>
                ต้องการลบอาหารใช่หรือไม่ ?
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#28ab28" class="white--text" height="50" @click="deleteFoodSuccess()">
                    บันทึก
                </v-btn>
                <v-btn color="error" height="50" @click="closeConfirmFoodDelete()">
                    ยกเลิก
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>

    <v-dialog v-model="open_confirm_delete_topping" persistent max-width="600px">
        <div v-if="loading_page_delete_topping === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <v-card v-if="loading_page_delete_topping === false">
            <v-card-title>
                คำเตือน
            </v-card-title>

            <v-card-text>
                ต้องการลบท็อปปิ้งใช่หรือไม่ ?
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#28ab28" class="white--text" height="50" @click="deleteToppingSuccess()">
                    บันทึก
                </v-btn>
                <v-btn color="error" height="50" @click="closeConfirmToppingDelete()">
                    ยกเลิก
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>

    <v-dialog v-model="open_confirm_delete_type_food" persistent max-width="600px">
        <div v-if="loading_page_delete_type_food === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <v-card v-if="loading_page_delete_type_food === false">
            <v-card-title>
                คำเตือน
            </v-card-title>

            <v-card-text>
                ต้องการลบประเภทอาหารใช่หรือไม่ ?
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#28ab28" class="white--text" height="50" @click="deleteTypeFoodSuccess()">
                    บันทึก
                </v-btn>
                <v-btn color="error" height="50" @click="closeConfirmTypeFoodDelete()">
                    ยกเลิก
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import before_image from "@/assets/fast-food.png";
export default {
    props: ['title'],
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            loading_page_add_typefood: true,
            loading_page_edit_typefood: true,
            loading_page_delete_food: true,
            loading_page_delete_topping: true,
            loading_up_down: false,
            food_image: before_image,
            alert_show_add_typefood: false,
            alert_show_status: false,
            open_confirm_delete_food: false,
            food_delete_id: null,
            alert_show_delete_food: false,
            open_confirm_delete_topping: false,
            topping_delete_id: null,
            alert_show_delete_topping: false,
            alert_show_delete_topping_false :false,
            message_delete_topping_false: null,
            open_type_food: false,
            open_edit_type_food: false,
            print_list: [],
            icon_list: [],
            type_food_name: null,
            type_food_name_en: null,
            printer_id: null,
            icon: null,
            type_status: null,
            show_website: false,
            data: [],
            edit_type_food_id: null,
            edit_type_food_name: null,
            edit_type_food_name_en: null,
            edit_printer_id: null,
            edit_icon: null,
            edit_type_status: null,
            edit_show_website: false,
            loading_page_delete_type_food: true,
            open_confirm_delete_type_food: false,
            type_food_delete_id: null,
            alert_show_delete_type_food: false,
        }
    },
    methods: {
        async menuFoodList() {
            this.loading_page = true
            this.data = []
            HTTP.get('/food/menu/list', {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.data = response.data.list
                        this.loading_page = false
                        this.loading_up_down = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async changeFoodStatus(id) {
            HTTP.post('/food/menu/status-update', {
                    id: id
                }, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.alert_show_status = true
                        setTimeout(() => this.alert_show_status = false, 5000)
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async printList() {
            this.loading_page_add_typefood = true
            this.open_type_food = true
            HTTP.get('/food/printer/list', {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.print_list = response.data.list_printer
                        this.icon_list = response.data.icon
                        this.printer_id = this.print_list[0].id
                        this.loading_page_add_typefood = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async addTypeFood() {
            if (this.$refs.form.validate()) {
                this.loading_page = true
                this.loading_page_add_typefood = true

                HTTP.post('/food/categories/create', {
                        name: this.type_food_name,
                        name_en: this.type_food_name_en,
                        printer_id: this.printer_id,
                        icon: this.icon,
                        type_status: this.type_status,
                        show_website: this.show_website == true ? 1 : 0,
                    }, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                    .then((response) => {
                        if (response.data.successful === true) {
                            this.type_food_name = null
                            this.printer_id = null
                            this.icon = null
                            this.type_status = null
                            this.show_website = false
                            this.loading_page_add_typefood = false
                            this.open_type_food = false
                            this.menuFoodList()
                            this.alert_show_add_typefood = true
                            setTimeout(() => this.alert_show_add_typefood = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
            }
        },
        async menuToppingList() {
            this.loading_page = true
            this.data = []
            HTTP.get('/toping/categories-list', {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.data = response.data.topingcategories
                        this.loading_page = false
                        this.loading_up_down = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async changeToppingStatus(id) {
            HTTP.post('/toping/status-update', {
                    id: id
                }, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.alert_show_status = true
                        setTimeout(() => this.alert_show_status = false, 5000)
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async detailTypeFood(id) {
            this.loading_page_edit_typefood = true
            this.open_edit_type_food = true
            this.edit_type_food_id = null
            this.edit_type_food_name = null
            this.edit_type_food_name_en = null
            this.edit_printer_id = null
            this.edit_icon = null
            this.edit_type_status = null
            this.edit_show_website = false

            await HTTP.get('/food/printer/list', {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.print_list = response.data.list_printer
                        this.icon_list = response.data.icon
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })

            await HTTP.get('/food/categories/detaile/' + id, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.edit_type_food_id = response.data.categoryDetaile.id
                        this.edit_type_food_name = response.data.categoryDetaile.foodCategory
                        this.edit_type_food_name_en = response.data.categoryDetaile.foodCategory_en
                        this.edit_printer_id = response.data.categoryDetaile.printer
                        // this.edit_icon = response.data.categoryDetaile.icon_id
                        // this.edit_type_status = response.data.categoryDetaile.type_status.toString()
                        // this.edit_show_website = response.data.categoryDetaile.show_website == 1 ? true : false
                        this.loading_page_edit_typefood = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async editTypeFood() {
            if (this.$refs.edit_form.validate()) {
                this.loading_page = true
                this.loading_page_edit_typefood = true

                HTTP.post('/food/categories/update/' + this.edit_type_food_id, {
                        name: this.edit_type_food_name,
                        name_en: this.edit_type_food_name_en,
                        printer_id: this.edit_printer_id,
                        icon: this.edit_icon,
                        type_status: this.edit_type_status,
                        show_website: this.edit_show_website == true ? 1 : 0,
                    }, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                    .then((response) => {
                        if (response.data.successful === true) {
                            this.edit_type_food_name = null
                            this.edit_type_food_name_en = null
                            this.edit_printer_id = null
                            this.edit_icon = null
                            this.edit_type_status = null
                            this.edit_show_website = false
                            this.loading_page_edit_typefood = false
                            this.open_edit_type_food = false
                            this.menuFoodList()
                            this.alert_show_add_typefood = true
                            setTimeout(() => this.alert_show_add_typefood = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
            }
        },
        async confirmTypeFoodDelete(id){
            this.loading_page_delete_type_food = true
            this.type_food_delete_id = id
            this.open_confirm_delete_type_food = true
            this.loading_page_delete_type_food = false
        },
        async closeConfirmTypeFoodDelete(){
            this.type_food_delete_id = null
            this.open_confirm_delete_type_food = false
        },
        async deleteTypeFoodSuccess() {
            this.loading_page = true
            this.loading_page_delete_type_food = true
            HTTP.post('/food/categories/delete/' + this.type_food_delete_id, null, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.type_food_delete_id = null
                        this.open_confirm_delete_type_food = false
                        this.menuFoodList()
                        this.alert_show_delete_type_food = true
                        setTimeout(() => this.alert_show_delete_type_food = false, 5000)
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async pageFoodDetail(id) {
            const idPage = {
                id: id
            }
            this.$store.commit('detailFoodPage', idPage)
            this.$router.push('/fooddetail')
        },

        async confirmFoodDelete(id) {
            this.loading_page_delete_food = true
            this.food_delete_id = id
            this.open_confirm_delete_food = true
            this.loading_page_delete_food = false
        },
        async closeConfirmFoodDelete() {
            this.food_delete_id = null
            this.open_confirm_delete_food = false
        },
        async deleteFoodSuccess() {
            this.loading_page = true
            this.loading_page_delete_food = true
            HTTP.post('/food/menu/delete/' + this.food_delete_id, null, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.food_delete_id = null
                        this.open_confirm_delete_food = false
                        this.menuFoodList()
                        this.alert_show_delete_food = true
                        setTimeout(() => this.alert_show_delete_food = false, 5000)
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async pageToppingDetail(id) {
            const idPage = {
                id: id
            }
            this.$store.commit('detailToppingPage', idPage)
            this.$router.push('/toppingdetail')
        },
        async confirmToppingDelete(id) {
            this.loading_page_delete_topping = true
            this.topping_delete_id = id
            this.open_confirm_delete_topping = true
            this.loading_page_delete_topping = false
        },
        async closeConfirmToppingDelete() {
            this.topping_delete_id = null
            this.open_confirm_delete_topping = false
        },
        async deleteToppingSuccess() {
            this.loading_page = true
            this.loading_page_delete_topping = true
            HTTP.post('/toping/delete/' + this.topping_delete_id, null, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.topping_delete_id = null
                        this.open_confirm_delete_topping = false
                        this.menuToppingList()
                        this.alert_show_delete_topping = true
                        setTimeout(() => this.alert_show_delete_topping = false, 5000)
                    }
                    if (response.data.successful === false) {
                        this.open_confirm_delete_topping = false
                        this.message_delete_topping_false = response.data.messages
                        this.alert_show_delete_topping_false = true
                        setTimeout(() => this.alert_show_delete_topping_false = false, 5000)
                        this.loading_page = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async changeNoFoodCategory(no, type, key) {
            this.loading_up_down = true
            this.message_show_up_down = null
            if (type == 'up') {
                HTTP.post('/upFoodCategory', {
                        number: no,
                    }, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                    .then((response) => {
                        if (response.data.successful === true) {

                            let up_value_id = this.data[key]['id']
                            let up_value_No = this.data[key]['No']
                            let up_value_name = this.data[key]['name']
                            let up_value_count = this.data[key]['count']
                            let up_value_menuList = this.data[key]['menuList']

                            this.data[key]['id'] = this.data[key - 1]['id']
                            this.data[key]['No'] = this.data[key - 1]['No'] + 1
                            this.data[key]['name'] = this.data[key - 1]['name']
                            this.data[key]['count'] = this.data[key - 1]['count']
                            this.data[key]['menuList'] = this.data[key - 1]['menuList']

                            this.data[key - 1]['id'] = up_value_id
                            this.data[key - 1]['No'] = up_value_No - 1
                            this.data[key - 1]['name'] = up_value_name
                            this.data[key - 1]['count'] = up_value_count
                            this.data[key - 1]['menuList'] = up_value_menuList

                            this.message_show_up_down = 'ปรับลำดับประเภทอาหารเรียบร้อย'
                            this.loading_up_down = false
                            this.alert_show_up_down = true
                            setTimeout(() => this.alert_show_up_down = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
            }
            if (type == 'down') {
                HTTP.post('/downFoodCategory', {
                        number: no,
                    }, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                    .then((response) => {
                        if (response.data.successful === true) {

                            let down_value_id = this.data[key]['id']
                            let down_value_No = this.data[key]['No']
                            let down_value_name = this.data[key]['name']
                            let down_value_count = this.data[key]['count']
                            let down_value_menuList = this.data[key]['menuList']

                            this.data[key]['id'] = this.data[key + 1]['id']
                            this.data[key]['No'] = this.data[key + 1]['No'] - 1
                            this.data[key]['name'] = this.data[key + 1]['name']
                            this.data[key]['count'] = this.data[key + 1]['count']
                            this.data[key]['menuList'] = this.data[key + 1]['menuList']

                            this.data[key + 1]['id'] = down_value_id
                            this.data[key + 1]['No'] = down_value_No + 1
                            this.data[key + 1]['name'] = down_value_name
                            this.data[key + 1]['count'] = down_value_count
                            this.data[key + 1]['menuList'] = down_value_menuList

                            this.message_show_up_down = 'ปรับลำดับประเภทอาหารเรียบร้อย'
                            this.loading_up_down = false
                            this.alert_show_up_down = true
                            setTimeout(() => this.alert_show_up_down = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
            }

        },
        async changeNoFood(no, type, key, key_detail, main_id) {
            this.loading_up_down = true
            this.message_show_up_down = null
            if (type == 'up') {
                HTTP.post('/upFood', {
                        number: no,
                        foodcategories_id: main_id,
                    }, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                    .then((response) => {
                        if (response.data.successful === true) {

                            let up_value_id = this.data[key]['menuList'][key_detail]['id']
                            let up_value_No = this.data[key]['menuList'][key_detail]['No']
                            let up_value_picture = this.data[key]['menuList'][key_detail]['picture']
                            let up_value_name = this.data[key]['menuList'][key_detail]['name']
                            let up_value_nameEng = this.data[key]['menuList'][key_detail]['nameEng']
                            let up_value_price = this.data[key]['menuList'][key_detail]['price']
                            let up_value_status = this.data[key]['menuList'][key_detail]['status']

                            this.data[key]['menuList'][key_detail]['id'] = this.data[key]['menuList'][key_detail - 1]['id']
                            this.data[key]['menuList'][key_detail]['No'] = this.data[key]['menuList'][key_detail - 1]['No'] + 1
                            this.data[key]['menuList'][key_detail]['picture'] = this.data[key]['menuList'][key_detail - 1]['picture']
                            this.data[key]['menuList'][key_detail]['name'] = this.data[key]['menuList'][key_detail - 1]['name']
                            this.data[key]['menuList'][key_detail]['nameEng'] = this.data[key]['menuList'][key_detail - 1]['nameEng']
                            this.data[key]['menuList'][key_detail]['price'] = this.data[key]['menuList'][key_detail - 1]['price']
                            this.data[key]['menuList'][key_detail]['status'] = this.data[key]['menuList'][key_detail - 1]['status']

                            this.data[key]['menuList'][key_detail - 1]['id'] = up_value_id
                            this.data[key]['menuList'][key_detail - 1]['No'] = up_value_No - 1
                            this.data[key]['menuList'][key_detail - 1]['picture'] = up_value_picture
                            this.data[key]['menuList'][key_detail - 1]['name'] = up_value_name
                            this.data[key]['menuList'][key_detail - 1]['nameEng'] = up_value_nameEng
                            this.data[key]['menuList'][key_detail - 1]['price'] = up_value_price
                            this.data[key]['menuList'][key_detail - 1]['status'] = up_value_status

                            this.message_show_up_down = 'ปรับลำดับอาหารเรียบร้อย'
                            this.loading_up_down = false
                            this.alert_show_up_down = true
                            setTimeout(() => this.alert_show_up_down = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
            }
            if (type == 'down') {
                HTTP.post('/downFood', {
                        number: no,
                        foodcategories_id: main_id,
                    }, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                    .then((response) => {
                        if (response.data.successful === true) {

                            let down_value_id = this.data[key]['menuList'][key_detail]['id']
                            let down_value_No = this.data[key]['menuList'][key_detail]['No']
                            let down_value_picture = this.data[key]['menuList'][key_detail]['picture']
                            let down_value_name = this.data[key]['menuList'][key_detail]['name']
                            let down_value_nameEng = this.data[key]['menuList'][key_detail]['nameEng']
                            let down_value_price = this.data[key]['menuList'][key_detail]['price']
                            let down_value_status = this.data[key]['menuList'][key_detail]['status']

                            this.data[key]['menuList'][key_detail]['id'] = this.data[key]['menuList'][key_detail + 1]['id']
                            this.data[key]['menuList'][key_detail]['No'] = this.data[key]['menuList'][key_detail + 1]['No'] - 1
                            this.data[key]['menuList'][key_detail]['picture'] = this.data[key]['menuList'][key_detail + 1]['picture']
                            this.data[key]['menuList'][key_detail]['name'] = this.data[key]['menuList'][key_detail + 1]['name']
                            this.data[key]['menuList'][key_detail]['nameEng'] = this.data[key]['menuList'][key_detail + 1]['nameEng']
                            this.data[key]['menuList'][key_detail]['price'] = this.data[key]['menuList'][key_detail + 1]['price']
                            this.data[key]['menuList'][key_detail]['status'] = this.data[key]['menuList'][key_detail + 1]['status']

                            this.data[key]['menuList'][key_detail + 1]['id'] = down_value_id
                            this.data[key]['menuList'][key_detail + 1]['No'] = down_value_No + 1
                            this.data[key]['menuList'][key_detail + 1]['picture'] = down_value_picture
                            this.data[key]['menuList'][key_detail + 1]['name'] = down_value_name
                            this.data[key]['menuList'][key_detail + 1]['nameEng'] = down_value_nameEng
                            this.data[key]['menuList'][key_detail + 1]['price'] = down_value_price
                            this.data[key]['menuList'][key_detail + 1]['status'] = down_value_status

                            this.message_show_up_down = 'ปรับลำดับอาหารเรียบร้อย'
                            this.loading_up_down = false
                            this.alert_show_up_down = true
                            setTimeout(() => this.alert_show_up_down = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
            }

        },
        async changeNoTopingCategory(no, type, key) {
            this.loading_up_down = true
            this.message_show_up_down = null
            if (type == 'up') {
                HTTP.post('/upTopingcategory', {
                        number: no,
                    }, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                    .then((response) => {
                        if (response.data.successful === true) {

                            let up_value_id = this.data[key]['id']
                            let up_value_No = this.data[key]['No']
                            let up_value_topingcategories_name = this.data[key]['topingcategories_name']
                            let up_value_toping_list = this.data[key]['toping_list']

                            this.data[key]['id'] = this.data[key - 1]['id']
                            this.data[key]['No'] = this.data[key - 1]['No'] + 1
                            this.data[key]['topingcategories_name'] = this.data[key - 1]['topingcategories_name']
                            this.data[key]['toping_list'] = this.data[key - 1]['toping_list']

                            this.data[key - 1]['id'] = up_value_id
                            this.data[key - 1]['No'] = up_value_No - 1
                            this.data[key - 1]['topingcategories_name'] = up_value_topingcategories_name
                            this.data[key - 1]['toping_list'] = up_value_toping_list

                            this.message_show_up_down = 'ปรับลำดับประเภทท็อปปิ้งเรียบร้อย'
                            this.loading_up_down = false
                            this.alert_show_up_down = true
                            setTimeout(() => this.alert_show_up_down = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
            }
            if (type == 'down') {
                HTTP.post('/downTopingcategory', {
                        number: no,
                    }, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                    .then((response) => {
                        if (response.data.successful === true) {

                            let down_value_id = this.data[key]['id']
                            let down_value_No = this.data[key]['No']
                            let down_value_topingcategories_name = this.data[key]['topingcategories_name']
                            let down_value_toping_list = this.data[key]['toping_list']

                            this.data[key]['id'] = this.data[key + 1]['id']
                            this.data[key]['No'] = this.data[key + 1]['No'] - 1
                            this.data[key]['topingcategories_name'] = this.data[key + 1]['topingcategories_name']
                            this.data[key]['toping_list'] = this.data[key + 1]['toping_list']

                            this.data[key + 1]['id'] = down_value_id
                            this.data[key + 1]['No'] = down_value_No + 1
                            this.data[key + 1]['topingcategories_name'] = down_value_topingcategories_name
                            this.data[key + 1]['toping_list'] = down_value_toping_list

                            this.message_show_up_down = 'ปรับลำดับประเภทท็อปปิ้งเรียบร้อย'
                            this.loading_up_down = false
                            this.alert_show_up_down = true
                            setTimeout(() => this.alert_show_up_down = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
            }

        },
        async changeNoToping(no, type, key, key_detail, main_id) {
            this.loading_up_down = true
            this.message_show_up_down = null
            if (type == 'up') {
                HTTP.post('/upToping', {
                        number: no,
                        toppingcategories_id: main_id,
                    }, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                    .then((response) => {
                        if (response.data.successful === true) {

                            let up_value_id = this.data[key]['toping_list'][key_detail]['id']
                            let up_value_No = this.data[key]['toping_list'][key_detail]['No']
                            let up_value_name = this.data[key]['toping_list'][key_detail]['name']
                            let up_value_status = this.data[key]['toping_list'][key_detail]['status']

                            this.data[key]['toping_list'][key_detail]['id'] = this.data[key]['toping_list'][key_detail - 1]['id']
                            this.data[key]['toping_list'][key_detail]['No'] = this.data[key]['toping_list'][key_detail - 1]['No'] + 1
                            this.data[key]['toping_list'][key_detail]['name'] = this.data[key]['toping_list'][key_detail - 1]['name']
                            this.data[key]['toping_list'][key_detail]['status'] = this.data[key]['toping_list'][key_detail - 1]['status']

                            this.data[key]['toping_list'][key_detail - 1]['id'] = up_value_id
                            this.data[key]['toping_list'][key_detail - 1]['No'] = up_value_No - 1
                            this.data[key]['toping_list'][key_detail - 1]['name'] = up_value_name
                            this.data[key]['toping_list'][key_detail - 1]['status'] = up_value_status

                            this.message_show_up_down = 'ปรับลำดับท็อปปิ้งเรียบร้อย'
                            this.loading_up_down = false
                            this.alert_show_up_down = true
                            setTimeout(() => this.alert_show_up_down = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
            }
            if (type == 'down') {
                HTTP.post('/downToping', {
                        number: no,
                        toppingcategories_id: main_id,
                    }, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                    .then((response) => {
                        if (response.data.successful === true) {

                            let down_value_id = this.data[key]['toping_list'][key_detail]['id']
                            let down_value_No = this.data[key]['toping_list'][key_detail]['No']
                            let down_value_name = this.data[key]['toping_list'][key_detail]['name']
                            let down_value_status = this.data[key]['toping_list'][key_detail]['status']

                            this.data[key]['toping_list'][key_detail]['id'] = this.data[key]['toping_list'][key_detail + 1]['id']
                            this.data[key]['toping_list'][key_detail]['No'] = this.data[key]['toping_list'][key_detail + 1]['No'] - 1
                            this.data[key]['toping_list'][key_detail]['name'] = this.data[key]['toping_list'][key_detail + 1]['name']
                            this.data[key]['toping_list'][key_detail]['status'] = this.data[key]['toping_list'][key_detail + 1]['status']

                            this.data[key]['toping_list'][key_detail + 1]['id'] = down_value_id
                            this.data[key]['toping_list'][key_detail + 1]['No'] = down_value_No + 1
                            this.data[key]['toping_list'][key_detail + 1]['name'] = down_value_name
                            this.data[key]['toping_list'][key_detail + 1]['status'] = down_value_status

                            this.message_show_up_down = 'ปรับลำดับท็อปปิ้งเรียบร้อย'
                            this.loading_up_down = false
                            this.alert_show_up_down = true
                            setTimeout(() => this.alert_show_up_down = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
            }
        },
    },
    computed: {
        icon_value() {
            let icon_value = this.icon_list.find((detail) => {
                return detail.id == this.icon
            })
            return icon_value.icon_name
        },
        edit_icon_value() {
            let icon_value = this.icon_list.find((detail) => {
                return detail.id == this.edit_icon
            })
            return icon_value.icon_name
        },
    },
    mounted() {
        this.menuFoodList()
    },
    watch: {
        title: function (newVal) {
            this.loading_page = true
            if (newVal == 'food') {
                this.menuFoodList()
            }
            if (newVal == 'topping') {
                this.menuToppingList()
            }
        }
    }
}
</script>

<style scoped>
@import '../../assets/font-pizzaro/css/font-pizzaro.css';

.menu_add_food {
    width: 100%;
    font-size: 22px;
}

.menu_add_food>div:first-child {
    width: 90%;
}

.menu_add_food>div:last-child {
    width: 10%;
}

.v-expansion-panel::before {
    box-shadow: unset !important;
    -webkit-box-shadow: unset !important;
}

.v-expansion-panel-content__wrap {
    padding: 0 !important;
}

.color_font_manage_food_type {
    border: 1px #038cc1 solid;
}

.color_font_manage_food_type>div {
    font-size: 20px;
}

.color_font_manage_food_type>div>span,
.color_font_manage_food_type>>>i {
    color: #038cc1 !important;
}

.color_font_manage_food_type>div>span:nth-child(2) {
    color: #ff5252 !important;
    margin-left: 5px;
}

.body_food_manage_food_type>>>.v-expansion-panel-content__wrap {
    padding: 0;
}

.img_modal_add_food {
    width: 50px;
}

.img_modal_add_food>img {
    max-width: 100%;
}

.img_menu_food_manage_food_type {
    width: 100px;
}

.img_menu_food_manage_food_type>img {
    max-width: 100%;
}

.w_status_manage_food_type {
    width: 15%;
}

.description_manage_food_type {
    color: #565656;
    font-size: 16px;
}

.page_detail_manage_food_type {
    position: absolute;
    right: 0;
    top: 0;
}

.page_edit_manage_food_type {
    cursor: pointer;
}

.w_full_detail_manage_food_type {
    width: 100%;
}

.w_full_name_detail_manage_food_type {
    width: 100%;
}

.icon_size_manage_food_type {
    font-size: 40px;
}

.loading_up_down {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
    background: rgba(0, 0, 0, 0.5);
}
</style>
